import { statinModerateIntensityActivity } from './definitions/activities/statinModerateIntensity';
import { ckdOngoingMeasurements } from './definitions/ckdOngoingMeasurements';
import { obesityOngoingMeasurements } from './definitions/obesityOngoingMeasurements';
import {
  hyperthyroidismOngoingMeasurements,
  hypothyroidismOngoingMeasurements,
} from './definitions/thyroidOngoingMeasurements';
import { t2dmOngoingMeasurements } from './definitions/t2dmOngoingMeasurements';
import { t2dmRoutineMonitoring } from './definitions/t2dmRoutineMonitoring';
import { insulinsValueSet, statinsValueSet, sulfonylureasValueSet } from './valueSets/rxNormDrugClasses';

/** The clinical protocols `@liza/medplum-config` deploys. */
export const planDefinitions = {
  t2dmRoutineMonitoring,
  t2dmOngoingMeasurements,
  ckdOngoingMeasurements,
  obesityOngoingMeasurements,
  hypothyroidismOngoingMeasurements,
  hyperthyroidismOngoingMeasurements,
};

/** What the protocols' suggestion actions propose, referenced by `definitionCanonical` and deployed alongside them. */
export const protocolActivityDefinitions = {
  statinModerateIntensityActivity,
};

/** The terminology the protocols reference, deployed alongside them. */
export const protocolValueSets = {
  insulinsValueSet,
  statinsValueSet,
  sulfonylureasValueSet,
};
